import { Theme, ThemedStyles } from 'ui/base/theme';

import baseStyles from './modules.module.css';

import moduleIconImageAlertsDaylight from './module_icons/alerts/light.png';
import moduleIconImageAlertsMidnight from './module_icons/alerts/dark.png';
import moduleIconImageBandwidthDaylight from './module_icons/bandwidth/light.png';
import moduleIconImageBandwidthMidnight from './module_icons/bandwidth/dark.png';
import moduleIconImageDevicesDaylight from './module_icons/devices/light.png';
import moduleIconImageDevicesMidnight from './module_icons/devices/dark.png';
import moduleIconImageHistoryDaylight from './module_icons/history/light.png';
import moduleIconImageHistoryMidnight from './module_icons/history/dark.png';
import moduleIconImageSchedulesDaylight from './module_icons/schedules/light.png';
import moduleIconImageSchedulesMidnight from './module_icons/schedules/dark.png';
import moduleIconImageVPNServerDaylight from './module_icons/vpnserver/light.png';
import moduleIconImageVPNServerMidnight from './module_icons/vpnserver/dark.png';

export type ModuleIconStyles = {
  alerts: string;
  bandwidth: string;
  devices: string;
  history: string;
  schedules: string;
  vpnserver: string;
};

export const themedModuleIconClassStyles: ThemedStyles<ModuleIconStyles> = {
  [Theme.DAYLIGHT]: {
    alerts: baseStyles.moduleIconClassAlertsDaylight,
    bandwidth: baseStyles.moduleIconClassBandwidthDaylight,
    devices: baseStyles.moduleIconClassDevicesDaylight,
    history: baseStyles.moduleIconClassHistoryDaylight,
    schedules: baseStyles.moduleIconClassSchedulesDaylight,
    vpnserver: baseStyles.moduleIconClassVPNServerDaylight,
  },
  [Theme.MIDNIGHT]: {
    alerts: baseStyles.moduleIconClassAlertsMidnight,
    bandwidth: baseStyles.moduleIconClassBandwidthMidnight,
    devices: baseStyles.moduleIconClassDevicesMidnight,
    history: baseStyles.moduleIconClassHistoryMidnight,
    schedules: baseStyles.moduleIconClassSchedulesMidnight,
    vpnserver: baseStyles.moduleIconClassVPNServerMidnight,
  },
};

export const themedModuleIconImageStyles: ThemedStyles<ModuleIconStyles> = {
  [Theme.DAYLIGHT]: {
    alerts: moduleIconImageAlertsDaylight,
    bandwidth: moduleIconImageBandwidthDaylight,
    devices: moduleIconImageDevicesDaylight,
    history: moduleIconImageHistoryDaylight,
    schedules: moduleIconImageSchedulesDaylight,
    vpnserver: moduleIconImageVPNServerDaylight,
  },
  [Theme.MIDNIGHT]: {
    alerts: moduleIconImageAlertsMidnight,
    bandwidth: moduleIconImageBandwidthMidnight,
    devices: moduleIconImageDevicesMidnight,
    history: moduleIconImageHistoryMidnight,
    schedules: moduleIconImageSchedulesMidnight,
    vpnserver: moduleIconImageVPNServerMidnight,
  },
};
